import { Link } from 'react-router-dom';

export function Producto({ info }) {

    const {
        id,
        Nombre,
        Imagen,
        Precio,
        Alcoholica,
        Contenido
    } = info;

    return (

        <li className="producto card m-2 bg-dark" style={{ width: `18rem` }}>
            <Link className='text-decoration-none producto-link' to={`/producto/${id}`}>
                <img className="card-img-top producto-imagen" src={Imagen} alt="" />
                <div className="producto-body card-body">
                    <h5 className="card-title"><b>{Nombre || ""}</b>({Contenido || ""})</h5>
                    <p className="card-text">{Alcoholica ? 'Alcohólica' : 'No alcohólica'}</p>
                    <p className="card-text">${Precio || ""}</p>
                    <button className="btn btn-primary w-100 producto-btn">Detalles</button>
                </div>
            </Link>

        </li >


    )
}
